module.exports = __webpack_public_path__ + "0a52668e8de3751030224f8d7fab862d.pdf";